import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Check, Crown } from 'lucide-react';
const pillars = ['Una ruta clara desde los fundamentos hasta la ejecución.', 'Amazon FBA y FBM explicados en un mismo programa.', 'Material práctico y organizado para avanzar con confianza.'];
export function Solution() {
  return <section className="bg-brand-white px-5 py-20 sm:px-6 md:py-28" data-id="element-862">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-20" data-id="element-863">
        <FadeIn data-id="element-864">
          <div className="relative overflow-hidden rounded-3xl bg-brand-green p-3 text-white sm:p-5 md:p-7" data-id="element-865">
            <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-brand-gold/10" data-id="element-866" />
            <div className="relative" data-id="element-867">
              <p className="mb-4 px-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-gold sm:mb-5" data-id="element-868">
                Un solo programa
              </p>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-4" data-id="element-869">
                <div className="overflow-hidden rounded-2xl border border-brand-gold/35 bg-black/20 shadow-[0_24px_45px_-16px_rgba(0,0,0,0.85)]" data-id="element-870">
                  <img src="https://cdn.magicpatterns.com/uploads/pB9QH7N2pHvhSxjDaPowXz/portada_como_vender_en_amazon_comprimida_(1).png" alt="Guía Amazon FBA incluida en Amazon Master System" loading="lazy" className="h-auto w-full object-contain" data-id="element-871" />
                </div>
                <div className="overflow-hidden rounded-2xl border border-brand-gold/35 bg-black/20 shadow-[0_24px_45px_-16px_rgba(0,0,0,0.85)] sm:mt-9" data-id="element-872">
                  <img src="https://cdn.magicpatterns.com/uploads/qck3xE7QCQPdxzAx4VgpMc/Pottada_FBM.png" alt="Guía Amazon FBM incluida en Amazon Master System" loading="lazy" className="h-auto w-full object-contain" data-id="element-873" />
                </div>
              </div>

              <div className="mx-2 mt-5 flex items-center gap-3 border-t border-white/10 pt-4 sm:mt-6 sm:pt-5" data-id="element-874">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-gold text-sm font-bold text-brand-green" data-id="element-875">
                  +
                </span>
                <p className="text-sm font-semibold leading-snug text-white/90" data-id="element-876">
                  FBA + FBM incluidos en un solo acceso
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-877">
          <div data-id="element-878">
            <div className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-879">
              <Crown className="h-4 w-4" data-id="element-880" />
              Método premium
            </div>
            <h2 className="font-serif text-4xl font-bold tracking-tight text-brand-green sm:text-5xl" data-id="element-881">
              Conoce Amazon Master System™
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-brand-text/70 sm:text-lg" data-id="element-882">
              Un programa completo que reúne en un solo lugar todo el
              conocimiento necesario para aprender Amazon desde cero.
            </p>

            <ul className="mt-8 space-y-4" data-id="element-883">
              {pillars.map(pillar => <li key={pillar} className="flex items-start gap-3" data-id="element-884">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-brand-gold/15" data-id="element-885">
                    <Check className="h-3 w-3 text-brand-green" strokeWidth={3} data-id="element-886" />
                  </span>
                  <span className="text-base font-medium leading-relaxed text-brand-text/80" data-id="element-887">
                    {pillar}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}